import { Directive, ElementRef, Renderer2, HostListener } from '@angular/core';
declare let $: any;
@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '.sub-menu-toggle',
    standalone: false
})
export class SubMenuToggleDirective {

  constructor(private readonly el: ElementRef, private readonly renderer: Renderer2) { }
  @HostListener('click')
  onClick() {
    const nativeEl = this.el.nativeElement;
    const parent = nativeEl.parentElement?.parentElement?.parentElement;
    const menu = nativeEl.closest('.menu');
    if(parent) this.renderer.addClass(parent, 'off-view')
    const slideableSubmenu = nativeEl.parentElement?.parentElement?.querySelector(':scope > .slideable-submenu');
    if (slideableSubmenu) {
      this.renderer.addClass(slideableSubmenu, 'in-view');
    }
    if (menu && slideableSubmenu) {
      menu.style.height = slideableSubmenu.offsetHeight + 'px';
    }
    return false;
  }


}
